// extracted by mini-css-extract-plugin
export default {"pageLayout":"Items_pageLayout__y+xgK"};